import React, { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { DirectionalLight } from "three";

const DirectionalLightComponent = ({
    color,
    intensity,
    position,
    colorRange,
    intensityRange,
    positionRange,
    randomizer,
    isExporting = false, // Wird während Export gesetzt
}) => {
    const lightRef = useRef();

    useFrame(() => {
        // Randomizer nur während Export aktivieren
        if (isExporting && randomizer && lightRef.current) {
            const randomColor = {
                r: Math.floor(
                    Math.random() * (colorRange.max - colorRange.min) + colorRange.min
                ),
                g: Math.floor(
                    Math.random() * (colorRange.max - colorRange.min) + colorRange.min
                ),
                b: Math.floor(
                    Math.random() * (colorRange.max - colorRange.min) + colorRange.min
                ),
            };

            const randomColorHex = `#${(
                "0" + randomColor.r.toString(16)
            ).slice(-2)}${("0" + randomColor.g.toString(16)).slice(-2)}${(
                "0" + randomColor.b.toString(16)
            ).slice(-2)}`;

            lightRef.current.color.set(randomColorHex);
            lightRef.current.intensity =
                Math.random() *
                (intensityRange.max - intensityRange.min) +
                intensityRange.min;
            lightRef.current.position.x =
                Math.random() *
                (positionRange.maxX - positionRange.minX) +
                positionRange.minX;
            lightRef.current.position.y =
                Math.random() *
                (positionRange.maxY - positionRange.minY) +
                positionRange.minY;
            lightRef.current.position.z =
                Math.random() *
                (positionRange.maxZ - positionRange.minZ) +
                positionRange.minZ;
        }
    });

    return (
        <directionalLight
            ref={lightRef}
            color={color}
            intensity={intensity}
            position={position}
        />
    );
};
export default DirectionalLightComponent;
